<template>
<div :ref="loadingobj">    

    <div>
        <div class="TTL-form-submit-box ">
            <el-form :inline="false">
                <el-form-item>
                    <div class="ER-box-info" v-for="(item,index) in settinginfo" :key="index" :ref="item.label">
                        <span class="ER-box-title right20">{{item.title}}</span>

                        <!-- 感兴趣商品数量开关 -->
                        <el-switch
                            v-if="item.label=='goods_interest'"
                            v-model="item.value"
                            class="ml-2"
                            @change="UpdateSetting(index)"
                        />
                        <!-- 抽佣比例 -->
                        <wcinputprex
                            v-if="item.label=='draw_percent'"
                            :value="item.value"
                            :option="{width:'150px',placeholder:'请填写数据',childname:'%',isinput:true}"
                            @finish="(val)=> {
                                item.value=val.value;
                                UpdateSetting(index)
                            }"
                        />



                        <!-- 加入微信群 -->
                        <el-switch
                            v-if="item.label=='saoma_qun'"
                            v-model="item.value"
                            class="ml-2"
                            @change="UpdateSetting(index)"
                        />
                        <!-- 加入微信群上传图片 -->
                        <wcupload :option="{size:'large', phototype:'system'}" 
                            class="left20"
                            v-if="item.label=='saoma_qun' && item.value==true"
                            :value="item.value1" 
                            @finish="(val)=> {
                                item.value1=val.url;
                                UpdateSetting(index)
                            }" 
                        />



                        <!-- 是否开启自动评论开关 -->
                        <el-switch
                            v-if="item.label=='auto_comment'"
                            v-model="item.value"
                            class="ml-2"
                            @change="UpdateSetting(index)"
                        />
                        <!-- 帖子评论时间范围 -->
                        <div class="er-box" v-if="item.label=='auto_comment' && item.value==true">
                            <span class="left30">发布</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'时间',clearable:true,ischange:true,width:'100px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.value1"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.value1=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                            <span class="left15">天内的帖子</span>
                        </div>
                        <div class="er-box" v-if="item.label=='auto_comment' && item.value==true">
                            <span>，每个帖子最多可评论</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'次数',clearable:true,ischange:true,width:'100px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.value2"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.value2=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                            <span class="left15">次</span>
                        </div>
                        <!-- 填充评论内容 -->
                        <div class="er-select-member left20" v-if="item.label=='auto_comment' && item.value==true" @click="openComment">
                            <div class="er-member-title">点击新增评论内容<h v-if="item.value4.length > 0">{{item.value4.length}}</h></div>
                            <div class="er-member-info right10" v-for="(comments,ii) in item.value4" :key="ii">
                                <span class="left5">{{comments}}</span>
                                <a class="left10" 
                                    @click.stop="(val) => {
                                        item.value4.splice(ii,1);
                                        UpdateSetting(index)
                                    }" 
                                />
                            </div>
                        </div>


                        <!-- 个人认证头像 -->
                        <wcupload :option="{size:'large', phototype:'system'}" 
                            class="left20"
                            v-if="item.label=='auto_person'"
                            :value="item.value1" 
                            @finish="(val)=> {
                                item.value1=val.url;
                                UpdateSetting(index)
                            }" 
                        />
                        <div class="er-box" v-if="item.label=='auto_person'">
                            <span class="left30">appcode</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'请填写实名认证appcode',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.value2"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.value2=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                            <span class="left30">开启自动认证</span>
                            <el-switch
                                v-model="item.value"
                                class="ml-2 left20"
                                @change="UpdateSetting(index)"
                            />
                        </div>

                        <!-- 企业认证头像 -->
                        <wcupload :option="{size:'large', phototype:'system'}" 
                            class="left20"
                            v-if="item.label=='auto_business'"
                            :value="item.value1" 
                            @finish="(val)=> {
                                item.value1=val.url;
                                UpdateSetting(index)
                            }" 
                        />
                        <div class="er-box" v-if="item.label=='auto_business'">
                            <span class="left30">appcode</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'请填写企业认证appcode',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.value2"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.value2=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                            <span class="left30">开启自动认证</span>
                            <el-switch
                                v-model="item.value"
                                class="ml-2 left20"
                                @change="UpdateSetting(index)"
                            />
                        </div>


                        <!-- 红包可塞入最大金额 -->
                        <div class="er-box" v-if="item.label=='xcx_red_setting'">
                            <span class="left20 right20">开启自动领红包</span>
                            <el-switch
                                v-model="item.value"
                                class="ml-2"
                                @change="UpdateSetting(index)"
                            />
                            <span class="left20 right20">，机器人可自动领取红包金额</span>
                            <wcinputprex
                                :value="item.value1"
                                :option="{width:'150px',placeholder:'请填写最大红包金额百分比',childname:'%',isinput:true}"
                                @finish="(val)=> {
                                    item.value1=val.value;
                                    UpdateSetting(index)
                                }"
                            />
                        </div>


                        <!-- 加群收费设置 -->
                        <el-switch
                            v-if="item.label=='xcx_add_qun'"
                            v-model="item.value"
                            class="ml-2"
                            @change="UpdateSetting(index)"
                        />
                        <div class="er-box" v-if="item.label=='xcx_add_qun'">
                            <span class="left30">，进群支付金额</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'请设置加群金额',clearable:true,ischange:true,width:'150px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.value1"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.value1=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                        </div>



                        <!-- 设置说明 -->   
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            placement="top"
                        >
                        <template #content>
                        <div class="box-item-note">{{item.note}}</div>
                        </template>
                        <div class="ER-question left20"><el-image :src="require('@/assets/icon/question.png')" /></div>
                        </el-tooltip>

                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>

<!-- 新增评论 -->
<AddComment :view="commentview" 
    @finish="(val)=>{
        AddCommentInfo(val);
    }" 
/>
</template>

<script>
import INTERFACE_MODEL_SETTING from '@/Interface/Es/setting';
import AddComment from '@/views/EsSetting/Module/AddComment';

export default {
    components:{AddComment},
    data() {
        return {
            loadingobj:'syssetting',
            settinginfo:[], //设置信息      
            sysnparam: {
                obj:'',
                loading:false,
                status:'',
                isstart:false,
            },

            //自动选择会员
            autoComment: {
                index:'',
                type:'',
            },

            //是否展示添加评论内容
            commentview:false,
            //微信公众号配置开关
            gzhsetting:false,


        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetSettingInfo();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                if(data.param.type=='selectmember') {
                    var data=data.param.data;
                    var settinglist=this.settinginfo[this.autoComment.index].value3;
                    var settinginfo='';
                    for(var i=0;i < settinglist.length; i++) settinglist[i].id==data.id? settinginfo=settinglist[i] : ''; //检查会员是否已存在
                    if(settinginfo=='') settinglist.push({id:data.id,nickname:data.name,thumb:data.thumb});
                    this.UpdateSetting(this.autoComment.index);

                }else {
                    this.GetSettingInfo();
                }

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetSettingInfo();
            }
        },


        /** 数据更新 **/
        UpdateSetting(index) {
            let data={};
            let datainfo={};

            for(var i=0;i < this.settinginfo.length;i++) {
                if(i!=index) continue;
                data=this.settinginfo[i];
                for(var i in data) datainfo[i]=data[i];
                if(datainfo.label=='goods_interest' || datainfo.label=='saoma_qun' || 
                    datainfo.label=='auto_comment' || datainfo.label=='auto_person' ||
                    datainfo.label=='auto_business' || datainfo.label=='xcx_red_setting' ||
                    datainfo.label=='xcx_add_qun') {
                    datainfo.value=datainfo.value? 1 : 0;
                }
                
                if(datainfo.label=='auto_comment') { //调整会员信息、评论信息
                    var memberids=[];
                    for(var ii=0;ii < datainfo.value3.length;ii++) memberids.push(datainfo.value3[ii].id);
                    datainfo.value3=memberids.join(',');
                    var commentlists=[];
                    for(var ii=0;ii < datainfo.value4.length;ii++) commentlists.push(datainfo.value4[ii]);
                    datainfo.value4=commentlists.join('|');
                }
            }
            INTERFACE_MODEL_SETTING.SAVE_SETTING_INFO(datainfo).then((res) => {
                if(res.status > 0) return false;
            });
        },



        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取运费信息数据 **/
        GetSettingInfo() {
            INTERFACE_MODEL_SETTING.GET_SETTING_INFO().then((res) => {
                if(res.status > 0) return false;
                this.settinginfo=res.data;
                for(let i=0;i<this.settinginfo.length;i++) {
                    if(this.settinginfo[i].label=='goods_interest' || this.settinginfo[i].label=='saoma_qun' || 
                        this.settinginfo[i].label=='auto_comment' || this.settinginfo[i].label=='auto_person' || 
                        this.settinginfo[i].label=='auto_business' || this.settinginfo[i].label=='xcx_red_setting' ||
                        this.settinginfo[i].label=='xcx_add_qun') {
                        Number(this.settinginfo[i].value)===1 ? 
                        this.settinginfo[i].value=true : this.settinginfo[i].value=false; //是否开启感兴趣商品数量开关
                    }
                }
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        /** 选择会员信息 **/
        selectMember(index,type) {
            this.autoComment.index=index;
            this.autoComment.type=type;
            this.$parent.JUMPVIEW({name:'EsMembers',param:{childtype:'selectmember',rollbackobjname:'EsEditSetting'}})
        },

        /** 打开窗口 **/
        openComment() {
            this.commentview=true;
        },

        /** 新增评论内容 **/
        AddCommentInfo(val) {
            this.commentview=false;
            if(val.content=='') return false;
            var comment;
            var settingindex='';
            for(var i=0; i < this.settinginfo.length; i++) {
                if(this.settinginfo[i].label=='auto_comment') {
                    settingindex=i;
                    comment=this.settinginfo[i].value4;
                    break;
                }
            }

            var index=-1;
            for(var i=0; i < comment.length; i++) {
                if(comment[i]==val.content) {
                    index=i;
                    break;
                }
            }
            if(index==-1) comment.push(val.content);
            this.UpdateSetting(settingindex);
        },


    },
}
</script>
<style scoped>
.ER-box-info {display: inline-flex;align-items: center;width:100%;padding:30px 0;}
.ER-box-title {font-size: 13px;color:#666666;}
.ER-question {width:15px;height: 15px;}
.ER-question .image {width:15px;height: 15px;}
.er-select-member {width:400px;height: 150px;border-radius: 15px;background-color: #F0F2F5;border:1px solid #D4D7DE;padding:0 20px 20px 20px;overflow-y: auto;cursor: pointer;}
.er-select-member::-webkit-scrollbar {width:0;}
.er-member-title {color:#666666;letter-spacing: 1px;padding:5px 0;font-size:12px;display: inline-flex;align-items: center;width:100%;font-weight: 550;position:sticky;top:0;background-color:#F0F2F5;z-index: 10;}
.er-member-title h {position: absolute;right:0;color:red;}
.er-member-info {padding:5px 8px;border-radius: 20px;border:1px solid #CDD0D6;display:inline-flex;align-items: center;background-color:#ffffff;margin-bottom:10px;position: relative;}
.er-member-info .el-image {width:20px;height:20px;border-radius: 50%;}
.er-member-info span {color:#666666;font-size:12px;line-height:18px;}
.er-member-info a {cursor: pointer;width:15px;height: 15px;background-image: url('@/assets/icon/close-blue.png');background-repeat: no-repeat;background-size: 15px;background-position: center;}
.er-box {display: inline-flex;align-items: center;}
.er-box span {font-size:12px;color:#666666;}
.box-item-note {width:100px;}
</style>